export default class TicketServiceMapEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#ticket_service_map_uuid") ? (elem.querySelector("#ticket_service_map_uuid") as HTMLInputElement).value : null,
            name: elem.querySelector("#ticket_service_name") ? (elem.querySelector("#ticket_service_name") as HTMLInputElement).value : (elem.querySelector("#ticket_service_map_name") as HTMLInputElement).value,
            service_id: (elem.querySelector("#ticket_service_map_service_id") as HTMLInputElement).value
        }
    }
}